import { useEffect } from 'react';
import { useTaskStore } from '../stores/taskStore';

export const useTaskDebug = () => {
  const { getDebugInfo, cleanupStaleActiveTasks } = useTaskStore();
  
  useEffect(() => {
    // Expose debug functions globally for easy access in console
    (window as any).taskDebug = {
      getInfo: () => {
        const info = getDebugInfo();
        console.log('Task Store Debug Info:', info);
        return info;
      },
      cleanup: () => {
        cleanupStaleActiveTasks();
        console.log('Cleaned up stale active tasks');
      },
      logTasks: () => {
        const info = getDebugInfo();
        console.table(info.activeTasksDetails);
        console.log('Task counts by status:', info.tasksByStatus);
        console.log('Orphaned active tasks:', info.orphanedActiveTasks);
        return info;
      }
    };
    
    console.log('Task debug functions available at window.taskDebug');
    
    return () => {
      delete (window as any).taskDebug;
    };
  }, [getDebugInfo, cleanupStaleActiveTasks]);
};